<template>
  <div>test</div>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'
export default {
  'name': 'InviteJoinFirst',
  components: {
  },
  data () {
    return {
      b: true,
      company: {}
      // invitecode: this.$route.query.invitecode || ''
    }
  },
  computed: {
    invitecode () {
      return this.$route.query.invitecode || '7e2f02483bc38ac254e9ed146e178f0e'
      //  return '987a57bf8fa69d89a5fb5c89afeb67d9'
    }
  },
  async mounted () {
    const auth = this.$store.state.auth
    this.setAuth(auth)
    if (this.invitecode) {
      this.setInviteCode(this.invitecode)
    }
    await this.fetchCompanyDatas()
  },
  methods: {
    ...mapActions('organization/inviteJoin', ['fetchCompanyDatas']),
    ...mapMutations('organization/inviteJoin', ['setInviteCode', 'setAuth'])
  }
}
</script>
